module.exports = __webpack_public_path__ + "static/assets/fcbf9726e0f3547b8334c2c52a8151a9.jpg";